export default __webpack_public_path__ + "static/media/Whatsapp.79c1585c.svg";